import { useCallback } from "react"

import {
  useTransportMutation,
  useTransportQuery,
  useTransportQueryUtils,
} from "@/transport"

import { logger } from "@/lib/logger"

const log = logger("usePersonaCatalogTransport")

export function usePersonaCatalogEntriesTransport() {
  return useTransportQuery({ operation: "listPersonaCatalogEntries" })
}

export function useCopyPersonaCatalogEntryTransport() {
  const mutation = useTransportMutation("copyPersonaCatalogEntry")
  const transportQueryUtils = useTransportQueryUtils()

  const copyPersonaCatalogEntry = useCallback(
    async (entryId: string) => {
      try {
        const response = await mutation.mutateAsync({ entry_id: entryId })
        return response.persona
      } finally {
        const [refresh] = await Promise.allSettled([
          transportQueryUtils.invalidateOperation("listPersonas"),
        ])
        if (refresh.status === "rejected") {
          log.error(
            "Persona list refresh failed after Catalog copy",
            refresh.reason,
          )
        }
      }
    },
    [mutation, transportQueryUtils],
  )

  return {
    copyPersonaCatalogEntry,
    isCopying: mutation.isPending,
  }
}
